














































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';   
import {DxLookup} from 'devextreme-vue/lookup';
import {DxTooltip} from 'devextreme-vue/tooltip';
import {DxButton} from 'devextreme-vue/button';
import _ from 'lodash';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { TextTemplateService } from '@/service/TextTemplateService';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import { DxCheckBox } from 'devextreme-vue';
import { ClientReportOptionDto } from '../../models/client/ClientReportOptionDto';
import { ClientService } from '@/service/ClientService';
import {DxValidator, DxRequiredRule} from 'devextreme-vue/validator';
import { DxNumberBox } from 'devextreme-vue/number-box';

@Component({
    components: { 
        DxLookup,
        DxButton,
        DxCheckBox,
        DxValidator,
        DxRequiredRule,
        DxNumberBox,
        DxTooltip
    }
})

export default class AnaylisReport extends Vue {
    $refs: Vue['$refs'] & {
        
    } = {};

    @Prop({default : false}) 
    visible!: boolean;

    @Prop({default : ''})
    clientId!: Guid;

    @Prop()
    clientReportOptionModel!: ClientReportOptionDto;

    get clientReportModel() {
        return this.clientReportOptionModel;
    }
    set clientReportModel(val: ClientReportOptionDto) {
        this.clientReportOptionModel = val;
    }

    get ClientId() : Guid {
        return this.clientId;
    }

    get visibility() : boolean {
        return this.visible;
    }

    @Watch("visible")
    async onVisibleChanged(newVal: boolean, oldVal: boolean) {
        if(newVal) {

        }
    }

    @Prop({ default: false })
    showEmailTemplate!: boolean;

    @Watch("showEmailTemplate")
    onValueChanged(newValue: boolean, oldValue: boolean) {
        if(!newValue) {
            this.analysisEmailDataSource.reload();
        }
    }

    bufferTooltip: boolean = false;
    textTemplateService: TextTemplateService;
    clientService: ClientService;
    analysisEmailStore: CustomStore = new CustomStore({
        loadMode: 'raw',
          load: (options): Promise<any> => {
          return this.textTemplateService.getTextTemplate(TextTemplateTypeEnum.AnalysisReport)
              .then((results : any) => {
                  return results;
              }
              
              )
              .catch(err=> []);
          }
    });
    analysisEmailDataSource: DataSource = new DataSource({
        store: this.analysisEmailStore,
        searchExpr: "Name"
    })
    toggleDefault(e: any) {
        this.bufferTooltip = !this.bufferTooltip;
    }

    constructor() {
        super();
        this.textTemplateService = new TextTemplateService();
        this.clientService = new ClientService();
      
        
    }
    onOpenTemplateEditor(e:any) {
        this.$emit("update:showEmailTemplate", true);
    }
}
